import React from "react";
import { Button } from "../Button";

export const HeroAction = ({ type, ...rest }) => {
  return (
    <Button type={type} size="l" {...rest}/>
  );
}